import { ChangeEvent } from "react";

export const evt = (name: string, value: any) => ({ target: { name, value } } as unknown as ChangeEvent)